import type { ButtonName, ClickStatus, SectionName } from '@coursera/event-pulse-types';
import { useTracker } from '@coursera/event-pulse/react';

import { useAuthModalTrackerContext } from 'bundles/authentication-common/contexts/AuthenticationTracking';

type EventData = {
  name: ButtonName;
  sectionName?: SectionName;
  clickStatus?: ClickStatus;
};
type TrackEvent = ({ name }: EventData) => void;

const useTrackClickButton = () => {
  const track = useTracker();
  const authModalEventingContext = useAuthModalTrackerContext();
  const { modalName, formName } = authModalEventingContext ?? {};
  const trackButton: TrackEvent = ({ name, sectionName, clickStatus }) =>
    track('click_button', {
      button: { name, ...(clickStatus && { clickStatus }) },
      ...(sectionName && { pageSection: { sectionName } }),
      ...(modalName && { modal: { name: modalName } }),
      ...(formName && { form: { name: formName } }),
    });

  return {
    trackButton,
  };
};

export default useTrackClickButton;
